
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/articles/[id]",
      function () {
        return require("private-next-pages/guides/articles/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/articles/[id]"])
      });
    }
  